<div class="news-detail-page">
  <div class="container py-5">

    <!-- Loading -->
    <div class="text-center my-5" *ngIf="loading">
      <app-loading></app-loading>
    </div>

    <!-- Back Button -->
    <div class="back-navigation mb-4" *ngIf="!loading && news" data-aos="fade-right">
      <a routerLink="/news" class="back-link">
        <i class="fa-solid fa-arrow-right mx-2"></i>
        العودة إلى الأخبار
      </a>
    </div>

    <!-- News Details -->
    <article class="news-detail-card" *ngIf="!loading && news" data-aos="fade-up">
      
      <!-- Hero Image -->
      <div class="news-hero-image" *ngIf="news.image">
        <img [src]="news.image" [alt]="news.title" />
        <div class="hero-overlay"></div>
        <div class="hero-content">
          <span class="category-badge-large">{{ news.category }}</span>
          <h1 class="hero-title">{{ news.title }}</h1>
        </div>
      </div>

      <!-- Content Section -->
      <div class="news-content-wrapper">
        
        <!-- Header Info (if no hero image) -->
        <div class="news-header" *ngIf="!news.image">
          <span class="category-badge-large">{{ news.category }}</span>
          <h1 class="news-main-title">{{ news.title }}</h1>
          <div class="news-date-meta">
            <i class="fa-solid fa-calendar mx-2"></i>
            <span>{{ news.createdAt | date:'fullDate' }}</span>
          </div>
        </div>

        <!-- Article Content -->
        <div class="news-article-content">
          <p class="article-body">
            {{ news.article || news.content || 'لا يوجد محتوى' }}
          </p>
        </div>

        <!-- Footer Meta -->
        <div class="news-footer-meta">
          <div class="meta-item">
            <i class="fa-solid fa-clock mx-2"></i>
            <span>نشر في {{ news.createdAt | date:'medium' }}</span>
          </div>
          <div class="meta-divider"></div>
          <div class="meta-item">
            <i class="fa-solid fa-tag mx-2"></i>
            <span>{{ news.category }}</span>
          </div>
          @if (news.editor) {
            <div class="meta-divider"></div>
            <div class="meta-item">
              <i class="fa-solid fa-user-pen mx-2"></i>
              <span>{{ news.editor }}</span>
            </div>
          }
        </div>

        <!-- Share Section -->
        <div class="share-section">
          <span class="share-label">شارك الخبر : </span>
          <div class="share-buttons">
            <a (click)="share(news)" class="share-btn link" title="مشاركة">
              <i class="fa-solid fa-share-nodes"></i>
            </a>
          </div>
        </div>

      </div>

    </article>

    <!-- Not Found -->
    <div class="not-found text-center py-5" *ngIf="!loading && !news" data-aos="fade-up">
      <i class="fa-solid fa-file-circle-question not-found-icon"></i>
      <h2 class="not-found-title">الخبر غير موجود</h2>
      <p class="not-found-text">عذراً، الخبر المطلوب غير موجود أو تم حذفه</p>
      <a routerLink="/news" class="btn-back">العودة إلى الأخبار</a>
    </div>

  </div>
</div>
  